import Boss from "@tencent/vft-common/Boss";
import { getVuid } from '@tencent/vft-common/login'

const DEFAULT_BIZ_ID = 'film_front_error',
  FATAL = 5,
  ERROR = 4,
  WARNING = 3,
  INFO = 2,
  DEBUG = 1;
let extend = Object.assign || function (dest, source) {
  if (!source || typeof source != 'object' || typeof dest != 'object') {
    return dest;
  }

  for (let k in source) {
    dest[k] = source[k];
  }

  return dest;
};
export default class Monitor {
  constructor({ bizId = DEFAULT_BIZ_ID, pageId }) {
    if (!pageId) {
      throw new Error('[@tencent/vft-monitor.Monitor.constructor]pageId is required');
    }
    this._boss = new Boss({
      bossId: 479,
      pwd: 0
    });
    this._bizId = bizId;
    this._pageId = pageId;
  }

  _report({ sBiz, modId = 'default', msg, file, line, fn, level, code, operate, pname = getVuid && getVuid() }) {
    if (!sBiz) {
      sBiz = `${this._bizId}.${this._pageId}.${modId}`;
    }
    this._boss.report({
      sBiz,
      errmsg: msg,
      srcfile: file,
      srcline: line,
      func: fn,
      level,
      iSta: code,
      sOp: operate,
      pname
    })
  }
  fatal(params) {
    this._report(extend(params, {
      level: FATAL
    }));
  }
  error(params) {
    this._report(extend(params, {
      level: ERROR
    }));
  }
  warn(params) {
    this._report(extend(params, {
      level: WARNING
    }));
  }
  info(params) {
    this._report(extend(params, {
      level: INFO
    }));
  }
  debug(params) {
    this._report(extend(params, {
      level: DEBUG
    }));
  }

  static getMonitor(pageId) {
    let monitor = this.pool[pageId];

    if (!monitor) {
      this.pool[pageId] = monitor = new Monitor({
        bizId: DEFAULT_BIZ_ID,
        pageId
      })
    }

    return monitor;
  }
}

Monitor.pool = {};